<template>
  <div class="list-wrapper">
    <div class="header" v-if='!isapplets'>
      <van-icon name="arrow-left" size="20" color="#fff" @click="goBack" />
    </div>
    <video-player
      class="video-player vjs-custom-skin"
      :options="playerOptions"
      @play="onplay($event)"
      @pause="onpause"
      @ended="onended"
    ></video-player>
    <div class="video_detail">
      <p class="video_name">{{name}}</p>
      <p class="video_time" v-if="total_length != 0">时长：{{total_length | formatSeconds}}</p>
    </div>
    <div class="other_videos">
      <p class="other_title">相关视频</p>
      <div class="video_region">
        <div v-for="i in video_list">
          <p
            class="single_video"
            v-for="item in i.children"
            v-if="item.module_type == 2"
            @click="play_next(item)"
          >
            <img class="video_pic" src="../../../static/images/video.png" alt />
            <span class="video_content">
              <span class="other_videos_name">{{item.name}}</span>
              <span class="video_params">
                视频
                <span v-if="item.video_time">| {{item.video_time | formatSeconds}}</span>
                <span v-if="item.menu_id == id" class="live_sign">
                  <img src="../../../static/images/living.gif" alt />正在播放
                </span>
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="class_dialog" v-if="zujian_flag">
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{ appname }}"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <span v-if='android' class="goapp"><a :href="scheme + '?type=2&orderSn=' + this.$route.query.order_id + '&package_id=' + this.$route.query.package_id + '&cid=' + this.$route.query.cid + '&menu_id=' + menu_id + '&spuID=' + shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid=appid
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
        </p>
      </div>
    </div>
    <div class="class_dialog" v-if="zujians_flag">
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{ appname }}"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <span v-if='android' class="goapp"><a :href="scheme + '?type=2&orderSn=' + this.$route.query.order_id + '&package_id=' + this.$route.query.package_id + '&cid=' + this.$route.query.cid + '&menu_id=' + menu_id + '&spuID=' + shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid=appid
            :extinfo="JSON.stringify({'type': 2, 'orderSn': this.$route.query.order_id, 'package_id': this.$route.query.package_id, 'cid': this.$route.query.cid, 'menu_id': menu_id, 'spuID': shopid, 'owner': this.$route.query.owner, 'channel': this.$route.query.channel, 'orgn': this.$route.query.orgn})"
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
        </p>
      </div>
    </div>
    <popup :data='detail' :type='1' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
    <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>
import popup from "../popup/index" //小程序弹窗
import record from "../../utils/record.js";
import videojs from "../../../static/js/video.js";
import formatSeconds from "../../utils/formatSecond.js";
import arouse from '../arouse/index.vue'
import timeFormats from "../../utils/timeFormat_record.js";
import wxapp from '../../utils/wxapp.js'
window.videojs = videojs;
require("videojs-flash");
videojs.options.flash.swf = "../../../static/video-js.swf";

export default {
  data() {
    return {
      name: this.$route.query.name,
      total_length: this.$route.query.time,
      id: this.$route.query.id,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        sources: [
          {
            type: "application/x-mpegURL",
            src: "", // 你的m3u8地址（必填）
          },
        ],
        controlBar: {
          timeDivider: true,
        },
        autoplay: true,
      },
      video_list: [],
      recordTimer: null,
      zujian_flag: false,
      zujians_flag: false,
      shopid: '',
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
      applets_flag: false,
      isapplets: false,
      detail: {},
      menu_id: '',
      appname: '',
      sf: '',
      scheme: '',
      arshow: false,
      appid: '',
      isweixin: false
    };
  },
  mounted() {
    wxapp.init()
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = true
      }
    })
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
    this.sf = this.$route.query.sf
    if (this.sf == 'zgyouzhi') {
      this.appid = 'wx91652b0b55a2ca52'
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
    this.getDetail()
    this.getM3u8(this.$route.query.media_id);
    this.getAllVideo();
  },
  filters: {
    formatSeconds: function (value) {
      return formatSeconds(value);
    },
  },
  components: {
    popup,
    arouse
  },
  methods: {
    receive (val) {
      this.arshow = val
    },
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      // this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      //判断iPhone|iPad|iPod|iOS
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
      } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
      } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    // 收集学习记录
    uprecord(current_position, total_length) {
      let inTime = new Date().getTime();
      let recordParams = {
        erp_id: this.$route.query.order_id,
        cid: this.$route.query.cid,
        package_id: this.$route.query.package_id,
        course_id: 1,
        unit_id: this.$route.query.id,
        action_time: timeFormats(new Date() / 1000),
        product: 2,
        is_online: 1,
        module_type: 2,
        current_position: current_position,
        total_length: total_length,
        course_type: 1,
        version: 0,
        other: {
          traceID: inTime,
        },
      };
      record(recordParams);
    },
    onplay(player) {
      this.uprecord(Math.floor(player.currentTime()), player.duration());
      let that = this;
      this.recordTimer = setInterval(function () {
        that.uprecord(Math.floor(player.currentTime()), player.duration());
      }, 60000);
    },
    onpause() {
      clearInterval(this.recordTimer);
      this.recordTimer = null;
    },
    onended() {
      clearInterval(this.recordTimer);
      this.recordTimer = null;
    },
    getDetail () {
      this.$api.GETDETAIL({
        system_order_num: this.$route.query.order_id,
        "offcn-ticket": localStorage.getItem("ticketObj") && JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: localStorage.getItem("ticketObj") && JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      }).then((res) => {
        if (res.code == 0) {
          this.shopid = res.data.goodsId || this.$route.query.spuid
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    },
    getM3u8(media) {
      this.$api
        .GETMEDIA({
          media_id: media,
          video_source: this.$route.query.video_source,
          "offcn-ticket": localStorage.getItem("ticketObj") && JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
          ticket_source: localStorage.getItem("ticketObj") && JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
        })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.media.url) {
              this.playerOptions.sources[0].src = res.data.media.url;
            } else {
              this.zujian_flag = true
              this.$nextTick(() => {
                var btn = document.getElementById('launch-btn')
                btn.addEventListener('launch', function(e) {
                  this.handleJudgeWechat(); //是否满足跳转app条件
                });
              })
            }
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
        .catch(() => {});
    },
    getAllVideo() {
      this.$api
        .GETCATALOG({
          system_order_num: this.$route.query.order_id,
          package_id: this.$route.query.package_id,
          coding: this.$route.query.cid,
          "offcn-ticket": localStorage.getItem("ticketObj") && JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
          ticket_source: localStorage.getItem("ticketObj") && JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
        })
        .then((res) => {
          if (res.code == 0) {
            this.video_list = res.data.catalog.list;
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
        .catch(() => {});
    },
    play_next(item) {
      if (item.learning_style.indexOf(2) == -1) {
        if (this.isapplets) {
          this.detail.order_id = this.$route.query.order_id
          this.detail.package_id = this.$route.query.package_id
          this.detail.cid = this.$route.query.cid
          this.detail.menu_id = item.menu_id
          this.detail.shopid = this.shopid
          this.applets_flag = true
        } else {
          this.menu_id = item.menu_id
          this.zujians_flag = true
        }
      } else {
        this.$router.push({
          path: "/video",
          query: {
            order_id: this.$route.query.order_id,
            package_id: this.$route.query.package_id,
            cid: this.$route.query.cid,
            media_id: item.video_id,
            name: item.name,
            time: item.video_time,
            id: item.menu_id,
            video_source: item.video_source,
            owner: this.$route.query.owner,
            channel: this.$route.query.channel,
            orgn: this.$route.query.orgn
          },
        });
        location.reload();
      }
    },
    popup () {
      this.applets_flag = false
    },
    cancel_flag() {
      this.zujian_flag = false
      this.zujians_flag = false
    },
    search_flag() {
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zgyouzhi'){
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=2&orderSn=' + this.$route.query.order_id + '&spuID=' + this.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
          }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=2&orderSn=' + this.$route.query.order_id + '&spuID=' + this.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    }
  }
};
</script>

<style lang="less">
.video-js .vjs-current-time {
  display: block;
}
.video-js .vjs-remaining-time{
  display: none;
}
#launch-btn {
  position: absolute;
  right: 0;
  width: 242px;
  height: 68px;
  opacity: 0;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  padding: 0 30px 0 25px;
  z-index: 2;
}
.video-player {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 422px;
  z-index: 1;
}
.video-js {
  width: 100%;
  height: 422px;
  .vjs-big-play-button {
    width: 100px;
    height: 90px;
    border-radius: 50%;
    top: 160px;
    left: 317px;
  }
}
.video_detail {
  background: #ffffff;
  padding: 30px 30px;
  padding-top: 452px;
  .video_name {
    font-size: 34px;
    font-weight: bold;
  }
  .video_time {
    margin-top: 20px;
    color: #999999;
  }
}
.other_videos {
  margin-top: 10px;
  background: #ffffff;
  .other_title {
    padding: 30px 30px 0;
    font-size: 34px;
    font-weight: bold;
  }
  .video_region {
    height: calc(100vh - 670px);
    overflow-y: scroll;
  }
  .single_video {
    display: flex;
    align-items: center;
    padding: 30px 30px;
    border-bottom: 1px solid #e6e6e6;
    .video_pic {
      width: 44px;
      height: 42px;
    }
    .video_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      .other_videos_name {
        font-size: 28px;
        font-weight: bold;
      }
      .video_params {
        color: #999999;
        margin-top: 20px;
        .live_sign {
          color: #94070a;
          float: right;
          img {
            width: 24px;
            height: 22px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
.class_dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
  z-index: 1;
  .dialog_box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 490px;
    line-height: 40px;
    border-radius: 18px;
    transform: translate(-50%, -50%);
    background: #fff;
    .dialog_message {
      text-align: center;
      padding: 30px 30px;
    }
    p {
      display: flex;
      border-top: 1px solid #e5e5e5;
      height: 70px;
      line-height: 70px;
      span {
        flex: 1;
        text-align: center;
      }
      .goapp {
        border-left: 1px solid #e5e5e5;
        a {
          color: #e60012;
        }
      }
    }
  }
}
.popop_content {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/video/index.vue